import { TransactionCodeService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from '../types/TCall';
import type { transactionsKeys } from './transactionsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof transactionsKeys.codeDetail>>;

export const createFetchTransactionCodeQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ code }], signal }: TParams) =>
    call(() => cancelOnSignal(TransactionCodeService.findOne({ code }), signal));
